import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import DescriptionIcon from "@material-ui/icons/Description";
import "../styles/NavBar.css";

const XIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="currentColor" style={{ verticalAlign: "middle" }}>
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
  </svg>
);

const MediumIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 640 512" fill="currentColor" style={{ verticalAlign: "middle" }}>
    <path d="M180.5 74.26C80.82 74.26 0 155.6 0 256S80.82 437.7 180.5 437.7 361 356.4 361 256 280.2 74.26 180.5 74.26zm321.6 30.64c-70.36 0-127.4 67.55-127.4 151.1s57 151.1 127.4 151.1 127.4-67.55 127.4-151.1-57-151.1-127.4-151.1zm116.8 41.52c-15.08 0-27.31 49.07-27.31 109.6s12.23 109.6 27.31 109.6 27.31-49.07 27.31-109.6-12.23-109.6-27.31-109.6z"/>
  </svg>
);

class NavBar extends React.Component {
  render() {
    return (
      <Navbar fixed="top" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="#">Omar Abdelsalam</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#intro">Home</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#experience">Experience</Nav.Link>

              <Nav.Link
                href="https://medium.com/@elusive1973"
                target="_blank"
                rel="noreferrer noopener"
              >
                Blog
              </Nav.Link>
            </Nav>

            <Nav className="ml-auto" style={{ display: "flex", alignItems: "center" }}>
              <Nav.Link href="mailto:omar.abdelsalam@gmail.com">
                <EmailRoundedIcon style={{ fontSize: 20 }} />
              </Nav.Link>

              <Nav.Link
                href="https://github.com/owvr27"
                target="_blank"
                rel="noreferrer noopener"
              >
                <GitHubIcon style={{ fontSize: 19 }} />
              </Nav.Link>

              <Nav.Link
                href="https://x.com/elusive1973"
                target="_blank"
                rel="noreferrer noopener"
              >
                <XIcon />
              </Nav.Link>

              <Nav.Link
                href="https://medium.com/@elusive1973"
                target="_blank"
                rel="noreferrer noopener"
              >
                <MediumIcon />
              </Nav.Link>

              <Nav.Link
                href="https://www.linkedin.com/in/omarr-abdelsalam"
                target="_blank"
                rel="noreferrer noopener"
              >
                <LinkedInIcon style={{ fontSize: 21 }} />
              </Nav.Link>

              <Nav.Link
                href={process.env.PUBLIC_URL + "/assets/Omar_Abdelsalam.pdf"}
                download="Omar_Abdelsalam.pdf"
              >
                <DescriptionIcon style={{ fontSize: 21 }} />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default NavBar;
